<template>
  <div class="layout-side-menu">
    <a-menu
      mode="horizontal"
      :inlineIndent="12"
      theme="dark"
      :selectedKeys="[]"
      style="line-height: 40px"
    >
      <YzsMenuItem :router="item" v-for="item in menuRouter" :key="item.id" />
    </a-menu>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref } from "vue";
import YzsMenuItem from "./YzsMenuItem.vue";
import store from "@/store";
export default defineComponent({
  name: "layoutMenu",
  computed: {
    menuRouter() {
      // const menuRouter = store.state.menu.menuRouter;
      const menuRouter = store.getters["menu/getMenuRouter"];
      return menuRouter.filter((item: any) => !item.hidden);
    },
  },
  components: {
    YzsMenuItem,
  },
  data: () => ({
    // menuRouter: datasource,
  }),
  props: {
    collapsed: {
      required: true,
      type: Boolean,
    },
  },
  setup() {
    const selectedKeys = ref<string[]>([]);
    const openKeys = ref<string[]>([]); // 确保 openKeys 正确绑定
    const portalName = import.meta.env.VITE_PORTAL_NAME;
    return { selectedKeys, openKeys, portalName };
  },
});
</script>
<style lang="scss">
.ant-menu-submenu-popup .ant-menu-submenu {
  margin-top: 0px;
  margin-bottom: 0px;
  color: #bcc2cb !important;
  background-color: #464d57 !important;
}

.ant-menu-submenu-popup .ant-menu-submenu:hover {
  background-color: lighten(#57616e, 10%) !important;
}

.ant-menu-submenu-popup .ant-menu-submenu .ant-menu-submenu-title:hover {
  color: #fff !important; // 鼠标悬停时字体颜色
}

.ant-menu-submenu-popup .ant-menu-submenu-title {
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>
<style lang="scss" scoped>
.layout-side-menu {
  position: relative;
  width: 100%;

  :deep(.ant-menu-submenu-title) {
    padding: 0 6px;
  }

  // 顶部菜单背景颜色和字体颜色
  :deep(.ant-menu-horizontal) {
    border-bottom: none !important;
    // background-color: #57616e !important; // 设置背景颜色
    color: #bcc2cb !important; // 设置字体颜色
  }

  // 子菜单背景颜色和字体颜色
  :deep(.ant-menu-submenu) {
    padding: 0px;
    // background-color: #57616e !important; // 设置背景颜色
    color: #bcc2cb !important; // 设置字体颜色
  }

  // 子菜单背景颜色和字体颜色
  :deep(.ant-menu-dark) {
    padding: 0px;
    background-color: #464d57 !important; // 设置背景颜色
    color: #bcc2cb !important; // 设置字体颜色
  }

  // 子菜单选中状态
  :deep(.ant-menu-submenu-selected .ant-menu-submenu-title::after) {
    border-bottom: 10px solid transparent;
  }

  // 顶部菜单项和子菜单项的背景颜色
  :deep(.ant-menu-horizontal > .ant-menu-item::after),
  :deep(.ant-menu-horizontal > .ant-menu-submenu::after) {
    right: 0px;
    left: 0px;
  }

  // 深色主题子菜单背景颜色和字体颜色
  :deep(.ant-menu-dark > .ant-menu-submenu) {
    // background-color: #57616e !important; // 设置背景颜色
    color: #bcc2cb !important; // 设置字体颜色
  }

  // 菜单项背景颜色和字体颜色
  :deep(.ant-menu-item) {
    // background-color: #57616e !important; // 设置背景颜色
    color: #bcc2cb !important; // 设置字体颜色
  }

  // 鼠标悬停时的背景颜色和字体颜色
  :deep(.ant-menu-item:hover),
  :deep(.ant-menu-submenu-title:hover) {
    background-color: lighten(#57616e, 10%) !important; // 鼠标悬停时背景颜色稍微变亮
    color: #fff !important; // 鼠标悬停时字体颜色
  }

  // 确保子菜单的显示样式正常
  :deep(.ant-menu-submenu-popup) {
    display: block !important; // 确保子菜单弹框正常显示
  }
}

// // 子菜单项的背景颜色和字体颜色
// :deep(.ant-menu-dark .ant-menu-submenu-popup) {
//   background-color: #464d57 !important; // 子菜单背景颜色
//   color: #fff !important; // 子菜单字体颜色
// }

// // 子菜单项鼠标悬停时的背景颜色和字体颜色
// :deep(.ant-menu-dark .ant-menu-submenu-popup .ant-menu-item:hover) {
//   background-color: lighten(#464d57, 10%) !important; // 鼠标悬停时背景颜色稍微变亮
//   color: #fff !important; // 鼠标悬停时字体颜色
// }
</style>
